/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXUpIcon32Regular = forwardRef('DataChartBarsXUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M25 3.25a1 1 0 0 1 1 1v17.5a1 1 0 1 1-2 0V4.25a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M20 8.25a1 1 0 1 0-2 0v13.5a1 1 0 1 0 2 0V8.25Z" }),
        React.createElement("path", { d: "M7 15.25a1 1 0 0 1 1 1v5.5a1 1 0 1 1-2 0v-5.5a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M3 27a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M14 12.25a1 1 0 1 0-2 0v9.5a1 1 0 1 0 2 0v-9.5Z" })));
});
